export default [
  // 根目录
  {
    path: '/',
    name: 'home',
    redirect: '/index',
    component(resolve) {
      require(['@/views/Home.vue'], resolve)
    }
  },
  // 首页
  {
    path: '/index',
    name: 'index',
    component(resolve) {
      require(['@/views/index/index.vue'], resolve)
    }
  },
  // 登录页
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '红山区教育一站通统一认证平台'
    },
    component(resolve) {
      require(['@/views/login/index.vue'], resolve)
    }
  },
  // 管理员登录页
  {
    path: '/admin/login',
    name: 'admin-login',
    meta: {
      title: '红山区教育一站通统一认证平台'
    },
    component(resolve) {
      require(['@/views/login/adminLogin.vue'], resolve)
    }
  },
  // 注册模块
  {
    path: '/register',
    name: 'register',
    redirect: '/register/choose',
    component: () => import('@/views/register/index.vue'),
    children: [
      // 选择角色
      {
        path: 'choose',
        name: 'register-choose',
        // meta: {
        //   title: '选择角色'
        // },
        // component(resolve) {
        //   require(['@/views/register/choose.vue'], resolve)
        // }
        component: () => import('@/views/register/choose.vue')
      },
      {
        path: 'info',
        name: 'register-info',
        // meta: {
        //   title: '填写信息'
        // },
        component: () => import('@/views/register/info.vue')
      },
    ]
  },
  // 找回密码页
  {
    path: '/changepassword',
    name: 'changepassword',
    // meta: {
    //   title: '修改密码'
    // },
    component(resolve) {
      require(['@/views/login/changepassword.vue'], resolve)
    }
  },
  // 消息管理
  {
    path: '/my',
    name: 'my',
    // meta: {
    //   title: '我的'
    // },
    component(resolve) {
      require(['@/views/my/index.vue'], resolve)
    }
  },
  // AI助理
  {
    path: '/ai',
    name: 'ai',
    // meta: {
    //   title: 'AI助理'
    // },
    component(resolve) {
      require(['@/views/ai/index.vue'], resolve)
    }
  },
  // 帮助中心
  {
    path: '/help',
    name: 'help',
    // meta: {
    //   title: '帮助中心'
    // },
    component(resolve) {
      require(['@/views/help/index.vue'], resolve)
    }
  },
  // 意见反馈
  {
    path: '/feedback',
    name: 'feedback',
    // meta: {
    //   title: '意见反馈'
    // },
    component(resolve) {
      require(['@/views/feedback/index.vue'], resolve)
    }
  },
  {
    path: '/message',
    name: 'message',
    // meta: {
    //   title: '意见反馈'
    // },
    component(resolve) {
      require(['@/views/message/index.vue'], resolve)
    }
  },
  {
    path: '/test',
    name: 'test',
    // meta: {
    //   title: '意见反馈'
    // },
    component(resolve) {
      require(['@/views/test/index.vue'], resolve)
    }
  },
  {
    path: '/noPermission',
    name: 'noPermission',
    component(resolve) {
      require(['@/views/noPermission/index.vue'], resolve)
    }
  },
  {
    path: '/unipass',
    name: 'unipass',
    component(resolve) {
      require(['@/views/unipass/index.vue'], resolve)
    }
  }
]
